if (!String.prototype.startsWith) String.prototype.startsWith = function (search, pos) {
  return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
};
//# sourceMappingURL=String.startsWith.js.map
